import ar from '../i18n/ar.json';
import de from '../i18n/de.json';
import en from '../i18n/en.json';
import es from '../i18n/es.json';
import fr from '../i18n/fr.json';
import ha from '../i18n/ha.json';
import it from '../i18n/it.json';
import pt from '../i18n/pt.json';
import sw from '../i18n/sw.json';
import vi from '../i18n/vi.json';
import yo from '../i18n/yo.json';
import { Language } from '../types/i18n';

/**
 * Translate a file according to a key and a lang
 * Works with subtree (object)
 * @param lang the lang to translate, default 'fr'
 * @param key the key to translate
 * @param {optional} args other arguments if variables need to be pass
 */
export default function translate(
  lang: Language,
  key: string,
  ...args: (string | number)[]
) {
  let translationFile;
  switch (lang) {
    case Language.ar:
      translationFile = ar;
      break;
    case Language.de:
      translationFile = de;
      break;
    case Language.en:
      translationFile = en;
      break;
    case Language.es:
      translationFile = es;
      break;
    case Language.ha:
      translationFile = ha;
      break;
    case Language.pt:
      translationFile = pt;
      break;
    case Language.sw:
      translationFile = sw;
      break;
    case Language.vi:
      translationFile = vi;
      break;
    case Language.yo:
      translationFile = yo;
      break;
    case Language.it:
      translationFile = it;
      break;
    default:
      translationFile = fr;
  }
  // get the value corresponding to the key from the Json file
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  let result = translationFile[key];
  // if no result as a string, check if it's a value in an object
  if (!result) {
    result = _accessObjectfromString('.', key, translationFile);
  }
  // if nothing, return the key
  if (!result) {
    return key;
  }

  // case when others arguments for variables
  if (Array.isArray(args) && args.length) {
    return result.replace(
      /{(\d+)}/g,
      (_: any, n: string | number) => args[+n - 1]
    );
  }

  return result;
}

/**
 * Access an object from a string with a separator
 * Example : string "a.b.c" in obj => return obj.a.b.c
 * @param separation the separation in the string of the elementToAccess
 * @param elementToAccess the string element to access in the object
 * @param object the object where the string want to access
 */
function _accessObjectfromString(
  separation: string,
  elementToAccess: string,
  object: any
) {
  return elementToAccess
    .split(separation)
    .reduce((o, i) => (o ? o[i] : o), object);
}
